import { SUBMENU_DEFAULT_VALUE } from '../../../constants/route'
import { getId2IdEndpoint } from '../../../utils/api'

// #INFO Connected (iDWELL-to-iDWELL) requests load files through the id2id
// proxy; for regular requests `undefined` is returned so the entity's default
// list endpoint is used.
export function getEntityTabDocumentsListApi(outboundUuid) {
  return outboundUuid
    ? getId2IdEndpoint({ outboundUuid, path: 'v4/file/filter/' })
    : undefined
}

export function getEntityTabDocumentsTableConfigApi({ entity, outboundUuid }) {
  return outboundUuid
    ? `idwell-api/api/v3/table/tables/${entity.plural}/?outbound_uuid=${outboundUuid}`
    : undefined
}

export function getEntityTabDocumentsFieldApi({
  objectId,
  outboundUuid,
  parent,
  scope,
  sub = SUBMENU_DEFAULT_VALUE,
}) {
  return getId2IdEndpoint({
    outboundUuid,
    path: `v4/file/single-field/?scope=${scope}&object_id=${objectId}&sub_menu=${sub}&parent=${parent}`,
  })
}
